export { default as AcceptableUse } from "./acceptableUse"
export { default as CompanyTerms } from "./companyTerms"
export { default as IndividualsTerms } from './individualsTerms'